<template>
    <v-app class="login">
        <div class="form-signin">
            <div class="text-center">
                <img src="/img/logo.svg" alt="" width="96" height="96">
                <slot name="title">
                    <h1>{{ $tr('Вход') }}</h1>
                </slot>
                <slot name="preamble"></slot>
                <v-progress-circular v-if="error == undefined && !has_auth && !has_pwd && mode != 'switch'" :size="100" :width="7"
                    color="green" indeterminate></v-progress-circular>
            </div>
            <v-card v-if="mode == 'switch'" class="mt-4">
                <v-list>
                    <v-list-item v-for="(account, index) in $api.accounts" :key="index" :prepend-avatar="account_avatar(account)"
                        :title="account_name(account)" :subtitle="account.user.uid" @click="switch_account(account)">
                    </v-list-item>
                    <v-list-item v-if="$api.multiaccount" @click="add_account" prepend-icon="mdi-account-plus"
                        :title="$tr('Добавить пользователя')">
                    </v-list-item>
                </v-list>
            </v-card>
            <div v-if="has_auth">
                <div v-for="item in auth" :key="item.id">
                    <a v-ripple :href="item.login" class="btn-face" :class="item.id">
                        <img :src="item.img" />
                        {{ item.name }}
                    </a>
                </div>
                <div v-if="has_pwd" class="divider">
                    <div class="text">{{ $tr("или") }}</div>
                </div>
            </div>
            <v-form v-if="has_pwd" v-model="form" @submit.prevent="login_pwd">
                <v-text-field autofocus="" clearable :label="$tr('Логин')" v-model="login" :readonly="loading"
                    :rules="[required]">
                </v-text-field>
                <v-text-field clearable :label="$tr('Пароль')" type="password" v-model="password" :readonly="loading"
                    :rules="[required]"
                    :error-messages="(!loading && pwd_error) ? $tr('Неправильное имя пользователя или пароль') : ''">
                </v-text-field>
                <v-btn block color="primary" variant="text" :disabled="!form" :loading="loading" type="submit">
                    {{ $tr('Войти') }}</v-btn>
            </v-form>
            <div class="copyrights text-center">
                {{ copyright }}
            </div>
        </div>
    </v-app>
</template>

<script>

import tid_img from '../assets/img/tid.svg';
import yandex_img from '../assets/img/yandex.svg';

import { AvatarUri } from '../md5';
import Utils from '../utils';

export default {
    name: 'TemplateLogin',
    data() {
        return {
            authority: {},
            error: undefined,
            login: '',
            password: '',
            form: false,
            loading: false,
            pwd_error: false,
        };
    },
    mounted() {
        this.initialize();
    },
    computed: {
        state() {
            return this.$router.payload.redirect_uri;
        },
        mode() {
            return this.$router.payload.mode || '';
        },
        has_pwd() {
            return this.authority.pwd != null;
        },
        has_auth() {
            return this.auth.length > 0;
        },
        auth() {
            const authority = this.authority;
            const auth = [];
            const tid = authority.tid;
            if (tid != null) {
                auth.push({
                    id: 'tid',
                    img: tid_img,
                    name: this.$tr('Topomatic ID'),
                    login: tid.login,
                });
            }
            const yandex = authority.yandex;
            if (yandex != null) {
                auth.push({
                    id: 'yandex',
                    img: yandex_img,
                    name: this.$tr('Yandex'),
                    login: yandex.login,
                });
            }
            return auth;
        },
        copyright() {
            const d = new Date();
            return `© 2003-${d.getFullYear()} НПФ "ТОПОМАТИК"`;
        },
    },
    watch: {
        password() {
            this.pwd_error = false;
        },
        login() {
            this.pwd_error = false;
        },
        mode() {
            this.initialize();
        },
    },
    methods: {
        initialize() {
            this.authority = {};
            this.error = undefined;
            this.form = false;
            this.loading = false;
            this.pwd_error = false;
            const payload = this.$router.payload;
            const mode = payload.mode || '';
            if (mode === '') {
                this.$api.authority(this.state)
                    .then((data) => {
                        this.authority = data;
                        const auth = this.auth;
                        if ((auth != null) && (auth.length === 1) && (!this.has_pwd)) {
                            window.document.location = auth[0].login;
                        }
                    })
                    .catch(this.handle_error);
            } else if (mode === 'authorize') {
                const access_token = payload.access_token;
                const expires_in = parseInt(payload.expires_in, 10);
                const token_type = payload.token_type || 'Bearer';
                const state = payload.state || '';
                this.$api.add_account(access_token, expires_in, token_type)
                    .then(() => {
                        this.$router.navigate(state);
                    })
                    .catch(this.handle_error);
            } else if (mode === 'switch') {
                // pass
            }
        },
        handle_error(e) {
            if (e != null) {
                if (e.statusText != null) {
                    this.error = e.statusText;
                } else {
                    this.error = e;
                }
                const uri = this.$router.href(this.$router.payload);
                setTimeout(() => {
                    if (uri === this.$router.href(this.$router.payload)) {
                        this.$router.push({
                            view: '',
                        });
                    }
                }, 50000);
            }
        },
        login_pwd() {
            if (!this.form) return;
            this.loading = true;
            this.$api.pwd(this.login, this.password).then((data) => {
                const access_token = data.access_token;
                const expires_in = data.expires_in;
                const token_type = data.token_type;
                const redirect_uri = this.$router.payload.redirect_uri || '';
                this.$api.add_account(access_token, expires_in, token_type)
                    .then(() => {
                        this.$router.navigate(redirect_uri);
                    })
                    .catch(this.handle_error);
            }).catch(() => {
                this.pwd_error = true;
            })
                .finally(() => {
                    setTimeout(() => { this.loading = false; }, 2000);
                });
        },
        required(v) {
            return !!v || this.$tr('Требуется заполнить поле');
        },
        account_avatar(account) {
            const user = account.user;
            const email = user.email || user.uid;
            if (email == null) {
                return undefined;
            }
            return AvatarUri(email, 40);
        },
        account_name(account) {
            const user = account.user;
            return Utils.userToString(user);
        },
        switch_account(account) {
            this.$api.switch_account(account).then(() => {
                const redirect_uri = this.$router.payload.redirect_uri || '';
                this.$router.navigate(redirect_uri);
            }).catch(() => {
                if (this.$api.accounts.length === 0) {
                    this.add_account();
                }
            });
        },
        add_account() {
            const redirect_uri = this.$router.payload.redirect_uri || '';
            this.$router.push({
                view: 'login',
                redirect_uri,
            });
        },
    },
};
</script>

<style scoped>
.login {
    display: flex;
    align-items: center;
    padding-top: 40px;
    padding-bottom: 40px;
    height: 100%;
}
.form-signin {
    width: 100%;
    max-width: 300px;
    padding: 15px;
    margin: auto;
}
.divider {
  position: relative;
  margin-bottom: 18px;
  margin-top: 17px;
}
.divider .text {
  width: 100%;
  text-align: center;
  position: relative;
  color: rgba(var(--v-theme-on-surface), 0.2);
  font-size: 14px;
  z-index: 1;
  overflow: hidden;
}
.divider .text:before,
.divider .text:after {
  width: 50%;
  top: 51%;
  overflow: hidden;
  height: 1px;
  background-color: rgba(var(--v-theme-on-surface), 0.2);
  content: '\a0';
  position: absolute;
}
.divider .text:before {
  margin-left: -52%;
  text-align: right;
}
.divider .text:after {
  margin-left: 2%;
}
.copyrights {
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    margin-bottom: 4px;
    color: rgba(var(--v-theme-on-surface), 0.4);
}
.btn-face {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
    width: 100%;
    height: 40px;
    border-radius: 0.25rem;
    box-shadow: 0 1px 5px 0 rgb(0 0 0 / 20%);
    transition: all .4s;
    position: relative;
    z-index: 1;
    color: #555;
    text-decoration: none;
    margin-bottom: 10px;
    margin-top: 10px;
}
.btn-face img {
    position: absolute;
    width: 24px;
    left: 15px;
}
.yandex {
    background: hsl(359, 85%, 53%);
    color: white;
}
.yandex:hover {
    background: hsl(359, 85%, 45%);
}
.tid {
    background: hsl(120, 100%, 25%);
    color: white;
}
.tid:hover {
    background: hsl(120, 100%, 22%);
}
</style>
